import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {parseNumber, roundUpToNearestRange} from '../methods/contentFormatHelpers';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ChartDataLabels
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: true,
      text: 'Kształtowanie się NPV w zależności od zmian wybranych parametrów',
    }
  }
};

export const optionsIrr = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
    },
    title: {
      display: true,
      text: 'Kształtowanie się IRR w zależności od zmian wybranych parametrów',
    }
  }
};
const labels = ['-20%', '-15%', '-10%', '-5%', '0%', '+5%', '+10%', '+15%', '+20%'];

interface AreaChartAnalisysProps {
    npv_sale: [],
    npv_price: [],
    npv_costs: [],
    npv_investment: [],
    irr? :boolean
}
// @ts-ignore
const AreaChartAnalisys = ( props: AreaChartAnalisysProps ) => {

  const option = props.irr?optionsIrr:options
  return (
    <Line
      options={{ ...option, scales: {
        y: props.irr?
            { max:2,
              min:0,
              ticks: { callback: function (value, index, ticks) { return  parseNumber(value)*100 + '%'}}
            } :
            {
            max: roundUpToNearestRange( Math.max(...props.npv_price.slice(0, 10), ...props.npv_investment.slice(0, 10), ...props.npv_sale.slice(0, 10), ...props.npv_costs.slice(0, 10))) ,
            min: roundUpToNearestRange( (Math.min(...props.npv_price.slice(0, 10), ...props.npv_investment.slice(0, 10), ...props.npv_sale.slice(0, 10), ...props.npv_costs.slice(0, 10)) ))
          }
      }, layout: {
        padding: {
          top: 50,
          right: 50,
        }
      }
      }}
      data={{
        labels,
        datasets: [
          {
            fill: false,
            label: 'Sprzedaż',
            data: props.npv_sale.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgb(255,212,0)',
            backgroundColor: 'rgba(175,131,18,0.5)',
            stack: 'stack1', // Set the same stack name for the second dataset
            datalabels: {
              display: false
            }
          },
          {
            fill: false,
            label: 'Cena',
            data: props.npv_price.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgb(47,255,107)',
            backgroundColor: 'rgba(67,136,34,0.5)',
            stack: 'stack2', // Set the same stack name for the second dataset
            datalabels: {
              display: false
            }
          },
          {
            fill: false,
            label: 'Koszt',
            data: props.npv_costs.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgb(246,46,76)',
            backgroundColor: 'rgba(141,10,63,0.5)',
            stack: 'stack3', // Set the same stack name for the second dataset
            datalabels: {
              display: false
            }
          },
          {
            fill: false,
            label: 'Nakłady inwestycyjne',
            data: props.npv_investment.slice(0, 10).map(elem => Math.round(elem*100)/100),
            borderColor: 'rgb(11,61,255)',
            backgroundColor: 'rgba(15,37,124,0.5)',
            stack: 'stack4', // Set the same stack name for the second dataset
            datalabels: {
              display: false
            }
          },
        ],
      }}
    />
  );
};

export default AreaChartAnalisys;